import { render, staticRenderFns } from "./GrantPrizeTable.vue?vue&type=template&id=f7736c28&scoped=true&"
import script from "./GrantPrizeTable.vue?vue&type=script&lang=js&"
export * from "./GrantPrizeTable.vue?vue&type=script&lang=js&"
import style0 from "./GrantPrizeTable.vue?vue&type=style&index=0&id=f7736c28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7736c28",
  null
  
)

export default component.exports